










































import { Component, Prop, Mixins } from "vue-property-decorator";
import IconCustom from "@/components/lib/IconCustom.vue";
import radioChoiceMixin from "@/mixins/radioChoiceMixin";
import inputThemeMixin from "@/mixins/inputThemeMixin";
import { isEqual } from "lodash";

@Component({
  components: {
    IconCustom,
  },
})
export default class InputSelect extends Mixins(
  radioChoiceMixin,
  inputThemeMixin
) {
  @Prop() readonly label?: string;
  @Prop() readonly required?: boolean;
  @Prop({ default: false }) readonly bordered?: boolean;
  @Prop({ default: false }) readonly min?: boolean;
  @Prop() colorCondition!: boolean;
  @Prop({ default: false }) fromLocaleChanger?: boolean;

  unmounted() {
    this.colorCondition = false;
  }

  get id(): string {
    // @ts-ignore
    return this._uid + "-select";
  }

  get getChBxColor(): boolean {
    return this.$store.getters.getCheckboxLabelColor;
  }

  get setColorInputLabel(): string {
    if (
      (isEqual(this.$route.path, "/travels") || this.$route.params.id) &&
      this.colorCondition
    ) {
      return this.getChBxColor && !this.fromLocaleChanger
        ? "#121212"
        : "#FFFFFF";
    }
    if (this.colorCondition && !this.fromLocaleChanger) {
      return "#121212";
    }
    return this.getChBxColor || this.$store.state.theme === "dark"
      ? "#FFFFFF"
      : "#121212";
  }
}
